var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('lDfault',{attrs:{"title":"登陆/注册"}},[_c('main',{staticClass:"main"},[_c('MainLogin',{attrs:{"fromRoute":_vm.fromRoute}}),_c('div',{staticClass:"forget-sign"},[_c('router-link',{attrs:{"to":"forgetPasswd"}},[_vm._v("忘记密码?")])],1),(_vm.wechatShow)?_c('div'):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }